import searchInitialState from "../../data/search";
import { AUTHORSEARCH, CATEGORYSEARCH, SEARCH } from "./actionTypes";

const searchReducer = (state = searchInitialState, action) => {
  switch (action.type) {
    case SEARCH:
      return {
        text: action.payload.toLowerCase(),
        type: SEARCH,
      };

    case CATEGORYSEARCH:
      return {
        text: action.payload.toLowerCase(),
        type: CATEGORYSEARCH,
      };
    case AUTHORSEARCH:
      return {
        text: action.payload.toLowerCase(),
        type: AUTHORSEARCH,
      };
    default:
      return state;
  }
};
export default searchReducer;
